module.exports = __webpack_public_path__ + "img/coinbankB25.9ab7d753.jpg";